import { i18n } from "next-i18next";

import SimpleApi from "./simple_api";

export default class ConfirmationCodeSignInApi extends SimpleApi {
  static startConfirmationCodeSignIn(confirmationCode, method = "sms") {
    return this.post(
      "/accounts/confirmation_code_sign_in/start_confirmation_code_sign_in",
      { confirmation_code: confirmationCode, method: method },
      {
        headers: {
          ACCEPT_LANGUAGE: i18n.language,
        },
      },
    );
  }

  static confirmPhoneVerificationCode(confirmationCode, verificationCode) {
    return this.post(
      "/accounts/confirmation_code_sign_in/confirm_phone_verification_code",
      {
        confirmation_code: confirmationCode,
        verification_code: verificationCode,
      },
      {
        headers: {
          ACCEPT_LANGUAGE: i18n.language,
        },
      },
    );
  }
}
